import { render, staticRenderFns } from "./MicrobiologyFilter.vue?vue&type=template&id=05b91854"
import script from "./MicrobiologyFilter.vue?vue&type=script&lang=js"
export * from "./MicrobiologyFilter.vue?vue&type=script&lang=js"
import style0 from "./MicrobiologyFilter.vue?vue&type=style&index=0&id=05b91854&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports